import { render, staticRenderFns } from "./popupMenu.vue?vue&type=template&id=90af0728&scoped=true&"
import script from "./popupMenu.vue?vue&type=script&lang=js&"
export * from "./popupMenu.vue?vue&type=script&lang=js&"
import style0 from "./popupMenu.vue?vue&type=style&index=0&id=90af0728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90af0728",
  null
  
)

export default component.exports